import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface DefaultStoreProjectAssigneesDeleteDialogIdleProps {
  selectedIdsCount: number;
  onCancel: () => void;
  onConfirm: () => void;
  isPending: boolean;
}

export const DefaultStoreProjectAssigneesDeleteDialogIdle = ({
  selectedIdsCount,
  onCancel,
  onConfirm,
  isPending,
}: DefaultStoreProjectAssigneesDeleteDialogIdleProps) => {
  const { t } = useTranslation();

  return (
    <>
      <DialogHeader>
        <DialogTitle>
          {t("defaultStoreProjectAssignees.deleteDialog.title")}
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          {t("defaultStoreProjectAssignees.deleteDialog.description", {
            count: selectedIdsCount,
          })}
        </p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onCancel} disabled={isPending}>
            {t("defaultStoreProjectAssignees.deleteDialog.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isPending}
          >
            {t("defaultStoreProjectAssignees.deleteDialog.confirm")}
          </Button>
        </div>
      </div>
    </>
  );
};
